<script setup lang="ts">
const casino = useCasinoStore();

const searchQuery = ref<string>('');
const isLoading = ref<boolean>(false);

/**
 * Podemos fazer isso pq o resultado é cacheado no build e nao faz request
 * se fizesse request n poderia colocar isso aqui ja que provavelmente
 * criaria um block em todo o render da pagina
 */
const resultQuery = ref<any>(await casino.getAllProviders());

const title = computed(() => {
  return `Provedores 🍀 ${appName()} | Cassino Online | Casa de Apostas`;
});

const description = computed(() => {
  return `Conheça os provedores de cassino disponíveis na ${appName()}. Jogos online autorizados em uma plataforma segura. 18+ | Jogue com responsabilidade.`;
});

useSeo({
  title: title.value,
  description: description.value,
});

watch(
  () => searchQuery.value,
  async () => {
    if (!casino.allProviders.length) {
      await casino.getAllProviders();
    }
    if (searchQuery.value) {
      const regex = new RegExp(searchQuery.value, 'gi');

      resultQuery.value = casino.allProviders.filter((provider) =>
        provider.name.match(regex),
      );
    } else {
      resultQuery.value = casino.allProviders;
    }
  },
);
</script>

<template>
  <section class="providers-page">
    <header class="providers-filters">
      <BaseSearchInput
        v-model="searchQuery"
        :is-loading="isLoading"
        :placeholder="$t('casino.providers.search_placeholder')"
      />
    </header>

    <div class="mt-6">
      <p class="text-texts font-semibold text-xs lg:text-base">
        {{ $t('casino.providers.all_providers') }}
      </p>

      <div class="providers-content lg:flex mb-10 mt-2 flex-wrap">
        <CasinoMediaList
          :is-loading="isLoading"
          :items="resultQuery"
          :per-row="{ 768: 3, 1100: 4, 1200: 5, desktop: 6 }"
          :space-between="[12, 10, 8]"
          type="provider"
        />
        <div
          v-if="!resultQuery.length && searchQuery"
          class="alert alert-warning"
        >
          {{ $t('components.search_bar.no_results') }}
        </div>
      </div>
    </div>

    <h1 class="text-white/60 text-center mb-8 px-4 leading-tight">
      Provedores de Jogos de Cassino
    </h1>
  </section>
</template>

<style scoped lang="scss">
.providers-page {
  @apply mx-auto max-w-lg md:max-w-2xl lg:max-w-full;

  .providers-content {
    .bt_link {
      @apply bg-white text-black py-3 px-5 rounded-md text-base gap-2 inline-flex m-0 items-center;
      @apply justify-center shadow-md hover:opacity-90 hover:text-primary whitespace-nowrap w-auto;
    }
  }
}
</style>
